import { render, staticRenderFns } from "./Create-Supplier.vue?vue&type=template&id=22fd03b2&scoped=true"
import script from "./Create-Supplier.vue?vue&type=script&lang=js"
export * from "./Create-Supplier.vue?vue&type=script&lang=js"
import style0 from "./Create-Supplier.vue?vue&type=style&index=0&id=22fd03b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd03b2",
  null
  
)

export default component.exports